import Component from './util/component';

class Content extends Component {
  constructor() {
    super(document.getElementById('content'));
  }
}

export default Content;
